import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import VideoFeedPaginated from "./VideoFeedPaginated";
import VideoFeedStatic from "./VideoFeedStatic";

const useStyles = makeStyles((theme) => ({
  feedRoot: {
    flexGrow: 1,
    marginBottom: 40,
  },
  cardRoot: {
    flexGrow: 1,
  },
  cardContent: {
    padding: 8,
    paddingBottom: 0,
  },
  feedTitle: {
    marginBottom: 16,
  },
  sdFeedTitle: {
    marginBottom: 16,
    fontSize: 28,
    fontWeight: 600,
    textTransform: "uppercase",
    color: "#1BD880",
  },
  title: {
    fontSize: 17,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  author: {
    marginTop: 6,
    color: "#676767",
    fontSize: 15,
  },
  avatar: {
    width: 18,
    height: 18,
  },
  media: {
    height: 160,
  },
  cardFooter: {
    display: "flex",
    justifyContent: "space-between",
  },
  videoMeta: {
    display: "flex",
  },
  views: {
    paddingLeft: 6,
  },
  viewsText: {
    marginLeft: 6,
    fontSize: 15,
  },
  postDate: {
    paddingLeft: 6,
    marginRight: 4,
  },
  emptyFeedText: {
    marginLeft: 12,
    fontSize: 16,
  },
}));

function VideoFeed({
  title,
  user,
  tag,
  game,
  upload,
  search,
  columns,
  variant,
  stableduel,
}) {
  const classes = useStyles();

  if (user || tag) {
    return (
      <VideoFeedPaginated
        classes={classes}
        title={title}
        columns={columns}
        variant={variant}
        stableduel={stableduel}
        user={user}
        tag={tag}
      />
    )
  }
  return (
    <VideoFeedStatic
      classes={classes}
      title={title}
      columns={columns}
      variant={variant}
      stableduel={stableduel}
      game={game}
      upload={upload}
      search={search}
    />
  )
}

export default VideoFeed;
